export const ArrowDownIcon = (props: any) => (
  <svg width="29" height="51" viewBox="0 0 29 51" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M14.4531 45.6934L14.4531 1.80664" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round"/>
    <path d="M1.91406 36.2891L13.746 48.121C14.1365 48.5115 14.7697 48.5115 15.1602 48.121L26.9922 36.2891" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round"/>
  </svg>
);
